import { IRewardData } from 'Utility/RewardHelper';
import { PayloadType } from 'Utility/SDK/PayloadType';

export interface ICustomPayload {
    data: PayloadType;
    messageId?: string;
    userId?: string;
    userAvatar?: string;
    userName?: string;
    additions?: any;
    reward?: IRewardData;
    cards?: number;
    placement: CustomPayloadPlacement;
}

export enum CustomPayloadPlacement {
    SOCIAL_HUB = 'SocialHub',
    TOP_LIST = 'TopList',
    SAGA_MAP = 'SagaMap',
}
